<div
    class="d-flex justify-content-center align-items-center vh-100"
    *ngIf="!formSubmitted">
    <form
        [formGroup]="unsubscribeForm"
        (ngSubmit)="onSubmit()"
        class="text-center w-50 p-4 border rounded">
        <div class="form-group">
            <h5 class="font-weight-bold mb-3">
                Please let us know why you're unsubscribing:
            </h5>
            <div id="reason" class="d-flex justify-content-center">
                <div class="d-flex flex-column align-items-start">
                    <div
                        *ngFor="let reasonOption of reasonOpions"
                        class="form-check mb-2">
                        <input
                            type="radio"
                            formControlName="reason"
                            [value]="reasonOption.value"
                            id="{{ reasonOption.label }}"
                            class="form-check-input" />
                        <label
                            for="{{ reasonOption.label }}"
                            class="form-check-label"
                            >{{ reasonOption.label }}</label
                        >
                    </div>
                </div>
            </div>
        </div>

        <button
            type="submit"
            class="btn btn-primary rounded-pill text-light mt-4">
            Unsubscribe
        </button>
    </form>
</div>
<div class="unsubscribe-container vh-100" *ngIf="formSubmitted">
    <h2 class="unsubscribe-title">
        You’re Unsubscribed
        <p class="unsubscribe-message">
            Thank you for your feedback. We’re sorry to see you go.
        </p>
        <p class="unsubscribe-message">
            Feel free to browse our auctions or simply close this tab.
        </p>
    </h2>
    <div class="button-group">
        <button class="btn btn-primary" (click)="goToAuctions()">
            Go To Auctions
        </button>
    </div>
</div>
